<nav #navBar
  [ngClass]="navCollapsed ? 'collapsed' : 'expanded' "
  class="side-navbar"
  id="navbar"
  role="navigation">

  <div (click)="toggleSidebar()" class="navbar-logo"><img [src]="'assets/img/' + (navCollapsed ? 'zynyoicon':'zynyo-logo') +'.svg'" alt="Zynyo Logo"></div>
  <div id="menu">
    <ul class="nav mt-3 mt-lg-4">
      @for (item of menuItems; track item) {
        <li [ngClass]="{'nav-heading': item.heading}" [routerLinkActive]="['active']">
          @if (item.heading) {
            @if (item.heading) {
              <span>{{ (item.text | translate) || item.text }}</span>
            }
          } @else {
            <a [routerLink]="item.link"
              [title]="(item.text | translate) || item.text"
              [tooltip]="navCollapsed ? (item.text | translate) || item.text : null">
              @if (item.icon) {
                <em class="{{item.icon}}"></em>
              }
              <span>{{(item.text | translate) || item.text}} </span>
            </a>
          }
        </li>
      }
    </ul>
  </div>
  <div class="p-3" id="user-menu">
    <a routerLink="/profile"><em class="fas fa-user fa-fw"></em> @if (!this.navCollapsed) {
    <span>{{ username }}</span>
  }</a>
  <a href="https://zynyo.atlassian.net/servicedesk/" target="_blank"><em class="fas fa-question fa-fw"></em> @if (!this.navCollapsed) {
  <span>{{ 'header.faq' | translate }}</span>
}</a>
<button (click)="logout()" class="mt-2 btn btn-logout"><em class="fas fa-sign-out-alt fa-fw"></em> @if (!this.navCollapsed) {
<span>{{ 'header.logout' | translate }}</span>
}</button>
</div>
</nav>
